import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f391fae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left flex-grow text-left" }
const _hoisted_2 = { class: "inline-block align-middle text-sm text-left cursor-pointer" }
const _hoisted_3 = { class: "date-hour text-left text-xs text-primary-800 font-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button bg-white text-primary cursor-pointer self-center self-center m-auto" }, "Vedi")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "notification-card h-full overflow-hidden bg-white rounded-lg items-center cursor-pointer link bg-white text-black justify-between align-middle items-center cursor-pointer flex focus:outline-none focus:shadow-outline",
    to: `/notifications/${_ctx.modelValue.id}`,
    type: "button"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.modelValue.title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.createdTs).format('HH:mm')), 1)
      ]),
      _hoisted_4
    ]),
    _: 1
  }, 8, ["to"]))
}